import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      navigate('/admin/applications', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please enter email and password');
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('adminUser', JSON.stringify({
        email: response.data.email,
        name: response.data.name,
        role: response.data.role,
      }));
      toast.success('Login successful');
      navigate('/admin/applications', { replace: true });
    } catch (error) {
      const msg = error.response?.data?.detail || 'Login failed';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-slate-100 mb-2">Admin Portal</h1>
          <p className="text-slate-400">PaySec Application Review</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-800 p-8 rounded-2xl shadow-2xl">
          <div className="space-y-5">
            <div>
              <Label htmlFor="admin-email" className="text-slate-200">Email</Label>
              <Input
                id="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-slate-900 border-slate-700 text-slate-100 h-11"
                placeholder="admin@paysec.ai"
                required
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <Label htmlFor="admin-password" className="text-slate-200">Password</Label>
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-slate-900 border-slate-700 text-slate-100 h-11"
                placeholder="Enter password"
                required
                data-testid="admin-login-password"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={submitting}
            className="w-full mt-6 bg-slate-200 text-slate-900 hover:bg-slate-100 font-semibold h-11"
            data-testid="admin-login-submit"
          >
            {submitting ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
